/**
 * @desc 从EBS全量获取银行信息数据
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/bankInfo/refreshBankInfo`, {
      method: "GET",

      ...options,
    }),
  );
}
